import Modal from 'components/Modal';
import Typography from 'components/Typography';
import styles from '../WebhookSettings.module.scss';
import TextField from 'components/TextField';
import SelectField from 'components/SelectField';
import {useForm, Controller} from 'react-hook-form';
import FormActionGroup from 'components/FormActionGroup';
import Button from 'components/Button';
import {SelectOption} from 'types';

type CreateWebhookFormData = {
  name: string;
  url: string;
  description: string;
  events: SelectOption[];
};

type CreateWebhookModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: {
    name: string;
    url: string;
    description: string;
    events: string[];
  }) => void;
  loading: boolean;
  eventOptions: SelectOption[];
};

function CreateWebhookModal({
  isOpen,
  onClose,
  onSubmit,
  loading,
  eventOptions,
}: CreateWebhookModalProps) {
  const {
    register,
    control,
    formState: {errors},
    handleSubmit,
  } = useForm<CreateWebhookFormData>({
    defaultValues: {
      name: '',
      url: '',
      description: '',
      events: [],
    },
  });

  const handleFormSubmit = (data: CreateWebhookFormData) => {
    onSubmit({
      name: data.name,
      url: data.url,
      description: data.description,
      events: data.events.map((e) => e.value as string),
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onRequestClose={onClose}
      className={styles.createWebhookModal}
    >
      <Typography variant="h2">Create Webhook</Typography>
      <TextField
        label="Name"
        placeholder="Enter webhook name"
        {...register('name', {required: 'Name is required'})}
        error={errors.name?.message}
      />
      <TextField
        label="Endpoint URL"
        placeholder="Enter endpoint URL"
        {...register('url', {required: 'Endpoint URL is required'})}
        error={errors.url?.message}
      />
      <TextField
        label="Description"
        placeholder="Enter description"
        {...register('description')}
        error={errors.description?.message}
      />
      <Controller
        name="events"
        control={control}
        rules={{required: 'At least one event is required'}}
        render={({field: {ref, ...field}, fieldState}) => (
          <SelectField
            label="Events"
            placeholder="Select events"
            options={eventOptions}
            // @ts-ignore
            isMulti
            error={fieldState.error?.message}
            {...field}
          />
        )}
      />
      <FormActionGroup className={styles.buttonWrap}>
        <Button
          type="submit"
          onClick={handleSubmit(handleFormSubmit)}
          loading={loading}
        >
          Create
        </Button>
      </FormActionGroup>
    </Modal>
  );
}

export default CreateWebhookModal;
